import axiosService, { axiosFileService } from '@services/axiosService';
import { S3_CONTAINER, S3_FOLDER_INTRO_MESSAGES } from '@config/config';

export const getIntroMessages = (token, filter) =>
  axiosService.get('/api/IntroMessages/get-active', {
    params: {
      access_token: token,
      filter,
    },
  });

export const createIntroMessage = ({ token, data }) =>
  axiosService.post(`/api/IntroMessages?access_token=${token}`, data);

export const assignIntroMessageToOrganization = ({ token, id, organizationId }) =>
  axiosService.post(
    `/api/IntroMessages/${id}/assign-to-organization/${organizationId}?access_token=${token}`,
  );

export const unassignIntroMessageFromOrganization = ({ token, organizationId }) =>
  axiosService.post(
    `/api/IntroMessages/unassign-from-organization/${organizationId}?access_token=${token}`,
  );

export const disableIntroMessage = ({ token, id }) =>
  axiosService.post(`/api/IntroMessages/${id}/deactivate?access_token=${token}`);

export const uploadIntroMessageFile = (file, token) => {
  const dataFormatted = new FormData();
  dataFormatted.append('file', file);
  return axiosFileService.post(`/api/containers/${S3_CONTAINER}/upload`, dataFormatted, {
    params: {
      access_token: token,
      subdirectory: S3_FOLDER_INTRO_MESSAGES,
    },
  });
};



// WEBPACK FOOTER //
// ./services/introMessagesResource.js